import React from "react"
import { useSelector } from "react-redux"

import { getToken } from "../services/helper"
import { IRedux } from "../services/types"
import NavBar from "./navbar"

const Header = () => {
  const settings = useSelector((state: IRedux) => state.settings?.extended)
  const event = useSelector((state: IRedux) => state.event)

  if (!event) return null

  return (
    <div style={{ width: "100%" }}>
      {settings && settings.headerImg ? (
        <img
          alt="header"
          src={`https://puzzle-system-files.s3.eu-west-3.amazonaws.com/front_office/headers/${settings.headerImg}`}
          style={{ width: "100%", marginBottom: "-10px" }}
        />
      ) : (
        <div style={{ padding: "20px 0", textAlign: "center" }}>
          {event.name}
        </div>
      )}
      {getToken() && <NavBar />}
    </div>
  )
}

export default Header
